import React from 'react';
import { teamDetails } from '../config/commonConfig';
import { FormattedMessage } from 'react-intl';

const Team = ({ classicHeader, darkTheme, lang }) => {
  const team = teamDetails[lang];
  return (
    <section id="team" className={'section main-padding'}>
      <div className={''}>
        {/* Heading */}
        <div className="position-relative d-flex text-center mb-5 mt-5">
          <p className={'text-9 text-dark fw-600 w-100 text-start'}>
            <FormattedMessage id="team" defaultMessage="Our Team" />
            <span className="heading-separator-line border-bottom border-3 border-primary d-block mx-auto" />
          </p>
        </div>
        <div className="row  gx-5 team-block">
          {team.length > 0 &&
            team.map((value, index) => (
              <div
                className="card mb-3"
                style={{ maxWidth: 540 }}
                key={value.name}>
                <div className="row g-0">
                  <div className="col-md-4">
                    <img
                      src={value.picture}
                      className="img-fluid rounded-start"
                      alt={value.name}
                    />
                  </div>
                  <div className="col-md-8">
                    <div className="card-body">
                      <h5 className="card-title">{value.name}</h5>
                      <p className="card-text">{value.desc}</p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
        </div>
        {/*  <div className="text-center mt-5">
          <a
            className="btn btn-outline-secondary rounded-pill shadow-none"
            href={resumeFile}
            download>
            Download CV
            <span className="ms-1">
              <i className="fas fa-download" />
            </span>
          </a>
        </div> */}
      </div>
    </section>
  );
};

export default Team;
